import { countSeens } from "../../student/video/func";

export const addVideo = async ({
    otp,
    playbackInfo,
    videoContainerRef,
    setDisplay,
    dispatch,
    data,
    setPlaybackStarted,
}) => {
    if (!otp || !playbackInfo) return;
    videoContainerRef.current?.classList.add("haveVideo");
    countSeens(dispatch, data);
    setPlaybackStarted(true);
    setDisplay("none");
};
